import { useState } from 'react';

/*
 * Calls `reset` in the render where `value` changes, so state picked under the
 * old value (a cohort, a user, page 4) never reaches a query under the new one.
 */
export function useResetOnChange<T>(value: T, reset: () => void): void {
  const [seen, setSeen] = useState(value);

  if (seen !== value) {
    setSeen(value);
    reset();
  }
}
